import React, { useState } from "react";
import {
  Phone,
  MapPin,
  Mail,
  MessageCircle,
  ArrowUpRight,
} from "lucide-react";
import PageHero from "../components/PageHero";
import { Section, SectionHeading, Eyebrow } from "../components/SectionPrimitives";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { SITE, waUrl } from "../lib/site";
const faqs = [
  {
    q: "Quanto custa anunciar no Google ou Meta?",
    a: "O investimento varia conforme segmento, região e concorrência. Após uma análise gratuita do seu mercado, recomendamos o orçamento ideal para atingir seus objetivos.",
  },
  {
    q: "Em quanto tempo aparecem os resultados?",
    a: "As campanhas normalmente começam a gerar resultados nos primeiros dias após a ativação. Para resultados mais consistentes, o período de 30 a 90 dias é o ideal para otimizações.",
  },
  {
    q: "Vocês atendem todo o Brasil?",
    a: "Sim. Atendemos empresas em qualquer cidade do país. Todo o processo é remoto com reuniões online, relatórios mensais e suporte via WhatsApp.",
  },
  {
    q: "O site fica no meu nome?",
    a: "Sim. Tanto o domínio quanto o site são de total propriedade do cliente. Você tem acesso completo a todas as credenciais.",
  },
  {
    q: "Como funciona o contrato?",
    a: "Trabalhamos com contratos transparentes e flexíveis. O cliente conhece todos os termos previamente, sem letras miúdas ou taxas escondidas.",
  },
  {
    q: "Vocês oferecem relatórios?",
    a: "Sim. Você recebe relatórios mensais detalhados, além de poder acompanhar os números em tempo real por dashboards próprios.",
  },
];

const services = [
  "Criação de Sites",
  "Google Ads",
  "Meta Ads (Facebook / Instagram)",
  "Combo Sites + Tráfego",
  "Outro / Não tenho certeza",
];

export default function Contato() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    service: services[0],
    message: "",
  });

  const onChange = (e) =>
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  const onSubmit = (e) => {
    e.preventDefault();
    const lines = [
      `Olá! Meu nome é ${form.name}.`,
      `E-mail: ${form.email}`,
      `Telefone: ${form.phone}`,
      `Serviço de interesse: ${form.service}`,
      "",
      `Mensagem: ${form.message || "—"}`,
    ];
    window.open(waUrl(lines.join("\n")), "_blank");
  };

  return (
    <div data-testid="page-contato">
      <PageHero
        breadcrumb="Contato"
        eyebrow="Vamos conversar"
        title="Pronto para impulsionar seu"
        highlight="negócio?"
        subtitle="Envie sua mensagem e nosso time entrará em contato em até 1 dia útil. Preferimos respostas rápidas — geralmente respondemos em minutos pelo WhatsApp."
      />

      <Section testId="contato-main">
        <div className="grid lg:grid-cols-12 gap-12">
          {/* Form */}
          <div className="lg:col-span-7">
            <Eyebrow color="#4285F4">Formulário</Eyebrow>
            <h2 className="font-display text-2xl sm:text-3xl font-bold text-[#000000] mt-3 mb-8">
              Solicite um orçamento sem compromisso.
            </h2>
            <form
              onSubmit={onSubmit}
              data-testid="contato-form"
              className="space-y-5"
            >
              <div className="grid sm:grid-cols-2 gap-5">
                <label className="block">
                  <span className="text-xs uppercase tracking-[0.15em] text-[#000000]/60">
                    Nome *
                  </span>
                  <input
                    name="name"
                    required
                    value={form.name}
                    onChange={onChange}
                    data-testid="contato-input-name"
                    className="mt-2 w-full border border-gray-200 px-4 py-3 focus:border-[#000000] outline-none bg-white"
                    placeholder="Seu nome"
                  />
                </label>
                <label className="block">
                  <span className="text-xs uppercase tracking-[0.15em] text-[#000000]/60">
                    E-mail *
                  </span>
                  <input
                    name="email"
                    type="email"
                    required
                    value={form.email}
                    onChange={onChange}
                    data-testid="contato-input-email"
                    className="mt-2 w-full border border-gray-200 px-4 py-3 focus:border-[#000000] outline-none bg-white"
                    placeholder="voce@email.com"
                  />
                </label>
              </div>
              <div className="grid sm:grid-cols-2 gap-5">
                <label className="block">
                  <span className="text-xs uppercase tracking-[0.15em] text-[#000000]/60">
                    Telefone / WhatsApp
                  </span>
                  <input
                    name="phone"
                    value={form.phone}
                    onChange={onChange}
                    data-testid="contato-input-phone"
                    className="mt-2 w-full border border-gray-200 px-4 py-3 focus:border-[#000000] outline-none bg-white"
                    placeholder="(48) 99999-9999"
                  />
                </label>
                <label className="block">
                  <span className="text-xs uppercase tracking-[0.15em] text-[#000000]/60">
                    Serviço de interesse
                  </span>
                  <select
                    name="service"
                    value={form.service}
                    onChange={onChange}
                    data-testid="contato-input-service"
                    className="mt-2 w-full border border-gray-200 px-4 py-3 focus:border-[#000000] outline-none bg-white"
                  >
                    {services.map((s) => (
                      <option key={s} value={s}>
                        {s}
                      </option>
                    ))}
                  </select>
                </label>
              </div>
              <label className="block">
                <span className="text-xs uppercase tracking-[0.15em] text-[#000000]/60">
                  Mensagem
                </span>
                <textarea
                  name="message"
                  rows={5}
                  value={form.message}
                  onChange={onChange}
                  data-testid="contato-input-message"
                  className="mt-2 w-full border border-gray-200 px-4 py-3 focus:border-[#000000] outline-none bg-white resize-none"
                  placeholder="Conte um pouco sobre o seu negócio e o que você precisa..."
                />
              </label>
              <p className="text-xs text-[#000000]/50">
                Ao enviar, você será redirecionado para o WhatsApp com seus
                dados pré-preenchidos. Nenhuma informação é armazenada em
                servidor.
              </p>
              <button
                type="submit"
                data-testid="contato-submit"
                className="btn-primary w-full justify-center"
              >
                Enviar via WhatsApp
                <ArrowUpRight size={18} />
              </button>
            </form>
          </div>

          {/* Info */}
          <aside className="lg:col-span-5">
            <Eyebrow color="#34A853">Contato direto</Eyebrow>
            <h2 className="font-display text-2xl sm:text-3xl font-bold text-[#000000] mt-3 mb-8">
              Fale com a O.G.
            </h2>

            <div className="space-y-px bg-gray-100 border border-gray-100">
              <a
                href={waUrl()}
                target="_blank"
                rel="noreferrer"
                data-testid="info-whatsapp"
                className="flex items-start gap-4 bg-white p-6 hover:bg-[#F8F9FA] transition"
              >
                <MessageCircle size={22} className="text-[#34A853] mt-1" />
                <div>
                  <p className="text-xs uppercase tracking-[0.15em] text-[#000000]/60">
                    WhatsApp
                  </p>
                  <p className="font-display font-semibold text-[#000000] text-lg mt-1">
                    {SITE.whatsappDisplay}
                  </p>
                  <p className="text-xs text-[#000000]/60 mt-1">
                    Resposta em minutos no horário comercial.
                  </p>
                </div>
              </a>

              <div className="flex items-start gap-4 bg-white p-6">
                <MapPin size={22} className="text-[#EA4335] mt-1" />
                <div>
                  <p className="text-xs uppercase tracking-[0.15em] text-[#000000]/60">
                    Endereço
                  </p>
                  <p className="font-display font-semibold text-[#000000] mt-1">
                    {SITE.address.line1}
                  </p>
                  <p className="text-sm text-[#000000]/70 mt-1">
                    {SITE.address.line2}
                    <br />
                    {SITE.address.cep}
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 bg-white p-6">
                <Phone size={22} className="text-[#4285F4] mt-1" />
                <div>
                  <p className="text-xs uppercase tracking-[0.15em] text-[#000000]/60">
                    Horário de atendimento
                  </p>
                  <p className="font-display font-semibold text-[#000000] mt-1">
                    Seg a Sex — 9h às 18h
                  </p>
                </div>
              </div>
            </div>

            {/* Mini Google color bar */}
            <div className="mt-8 g-stripe" />
            <p className="mt-4 text-xs uppercase tracking-[0.2em] text-[#000000]/50">
              Google Partner — Certificação Oficial
            </p>
          </aside>
        </div>
      </Section>

      {/* MAPA */}
      <Section testId="contato-map" className="bg-[#F8F9FA] border-t border-gray-100">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-4">
            <Eyebrow color="#EA4335">Nosso endereço</Eyebrow>
            <h2 className="font-display text-2xl sm:text-3xl font-bold text-[#000000] mt-3 mb-5">
              Onde nos encontrar.
            </h2>
            <p className="text-[#000000]/70 leading-relaxed">
              <strong className="text-[#000000]">{SITE.address.line1}</strong>
              <br />
              {SITE.address.line2}
              <br />
              {SITE.address.cep}
            </p>
            <a
              href="https://www.google.com/maps/search/?api=1&query=Centro+Empresarial+Corporate+Park+Florianopolis+88050-001"
              target="_blank"
              rel="noreferrer"
              data-testid="open-in-google-maps"
              className="inline-flex items-center gap-2 mt-6 text-sm font-medium text-[#000000] border-b border-[#000000] pb-1 hover:gap-3 transition-all"
            >
              <MapPin size={16} className="text-[#EA4335]" />
              Abrir no Google Maps
            </a>
          </div>
          <div
            className="lg:col-span-8 border border-gray-200 overflow-hidden"
            data-testid="contato-map-frame"
          >
            <iframe
              title="Localização — O.G. Marketing Digital"
              src="https://www.google.com/maps?q=Centro+Empresarial+Corporate+Park+Florianopolis+88050-001&output=embed"
              width="100%"
              height="380"
              style={{ border: 0, display: "block" }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </Section>

      {/* FAQ */}
      <Section testId="contato-faq" className="bg-[#F8F9FA] border-y border-gray-100">
        <SectionHeading
          eyebrow="Perguntas frequentes"
          title="Tudo o que você precisa saber."
        />
        <Accordion
          type="single"
          collapsible
          className="max-w-3xl bg-white border border-gray-100"
          data-testid="faq-accordion"
        >
          {faqs.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              className="px-6 border-b border-gray-100 last:border-b-0"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-display font-semibold text-[#000000] hover:no-underline py-5"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${i}`}
                className="text-[#000000]/70 leading-relaxed pb-5"
              >
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Section>
    </div>
  );
}
